// Same rules as AuthService.validateNewPassword: 16+ characters, a lower and upper case letter,
// a digit, and anything that is not a letter or digit counts as special (so _ - + ~ do).

export interface PasswordValidation {
    length: boolean;
    lowercase: boolean;
    uppercase: boolean;
    number: boolean;
    special: boolean;
}

export const validatePassword = (password: string): PasswordValidation => ({
    length: password.length >= 16,
    lowercase: /\p{Ll}/u.test(password),
    uppercase: /\p{Lu}/u.test(password),
    number: /\p{Nd}/u.test(password),
    special: /[^\p{L}\p{N}]/u.test(password),
});

export const isPasswordValid = (validation: PasswordValidation): boolean =>
    Object.values(validation).every(Boolean);

export const PasswordRequirements = ({ validation }: { validation: PasswordValidation }) => (
    <div className="mt-3 space-y-2">
        <p className="text-sm font-medium text-gray-700">Password Requirements:</p>
        <ul className="space-y-1 text-sm">
            <li className={validation.lowercase ? 'text-green-600' : 'text-red-600'}>
                • One lowercase letter
            </li>
            <li className={validation.uppercase ? 'text-green-600' : 'text-red-600'}>
                • One uppercase letter
            </li>
            <li className={validation.number ? 'text-green-600' : 'text-red-600'}>
                • One number
            </li>
            <li className={validation.special ? 'text-green-600' : 'text-red-600'}>
                • One special character
            </li>
            <li className={validation.length ? 'text-green-600' : 'text-red-600'}>
                • At least 16 characters
            </li>
        </ul>
    </div>
);
